import React from 'react';
import { Truck, CheckCircle2 } from 'lucide-react';
export function TruckGlass() {
  const points = ['Truck windshield repair and replacement', 'Semi truck glass and commercial truck glass', 'Fleet account service options', 'Heavy-duty and work truck side, door and rear glass'];
  return <section className="py-16 lg:py-24 bg-slate-50 border-t border-slate-200" data-id="element-435">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-436">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-437">
          <div className="scroll-fade-up" data-id="element-438">
            <div className="w-12 h-12 bg-brand-light rounded-xl flex items-center justify-center mb-6" data-id="element-439">
              <Truck className="w-6 h-6 text-brand-blue" data-id="element-440" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-441">
              Truck, Semi & Fleet Glass
            </h2>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed" data-id="element-442">
              Downtime is expensive. Kosin's Glass repairs and replaces
              windshields and side glass for pickups, work trucks, semi trucks
              and commercial fleets across Southeast Michigan.
            </p>
            <p className="text-slate-600 mb-8 leading-relaxed" data-id="element-443">
              Ask about fleet account options to streamline scheduling, billing
              and recurring service for multiple vehicles.
            </p>
            <a href="#quote" className="inline-flex items-center text-brand-blue font-bold hover:text-brand-hover transition-colors group" data-id="element-444">
              Request a Truck or Fleet Glass Quote
              <span className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-445">
                →
              </span>
            </a>
          </div>

          <div className="bg-white rounded-2xl p-8 border border-slate-200 shadow-sm scroll-fade-scale" style={{
          animationDelay: '0.15s'
        }} data-id="element-446">
            <h3 className="text-xl font-bold text-navy-900 mb-6" data-id="element-447">
              What's Covered
            </h3>
            <ul className="space-y-5" data-id="element-448">
              {points.map((point, i) => <li key={i} className="flex items-start gap-4" data-id="element-449">
                  <div className="w-6 h-6 rounded-full bg-brand-light flex items-center justify-center shrink-0 mt-0.5" data-id="element-450">
                    <CheckCircle2 className="w-4 h-4 text-brand-blue" data-id="element-451" />
                  </div>
                  <span className="text-slate-700 font-medium" data-id="element-452">{point}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}